var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 313,
    height: 211,
    viewBox: "0 0 313 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.9 208.081L173.679 169.5L150.953 208.081H123.739L158.7 149.972L123.059 96.0195H151.5L174.318 132.043L196.095 96.0195H223.308L188.255 151.736L224.268 208.081H196.9Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M312.736 169.996C312.736 194.651 294.776 210.022 270.44 210.022C248.983 210.022 230.323 198.179 228.559 172.4H251.769C253.368 183.603 260.671 188.41 270.44 188.41C282.603 188.41 289.526 180.24 289.526 169.676C289.526 159.113 281.798 150.206 270.44 150.206C262.928 150.206 256.36 152.497 251.429 161.032H229.239L236.904 96.0312H309.879L307.444 117.808H255.236L253.162 139.317C253.162 139.317 258.65 132.859 275.259 132.859C295.282 132.859 312.726 146.301 312.726 169.996",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M231.303 82.0733C218.945 33.8671 179.713 0 98.3002 0H0L13.3385 90.2228C23.3758 171.636 54.5092 197.828 109.617 207.473C109.875 207.515 111.618 207.762 111.639 205.72C111.639 204.987 111.185 204.348 110.545 204.079C73.3048 188.399 69.0546 136.974 61.0907 85.364L54.9322 44.2346H111.04C162.775 44.2346 202.718 43.4196 228.002 83.3524C228.373 83.9095 228.961 84.3325 229.663 84.3325C230.643 84.3325 231.365 83.5381 231.365 82.5581C231.365 82.3827 231.344 82.2177 231.293 82.063",
    fill: "#5FAF2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX5);
export default __webpack_public_path__ + "static/media/x5.de05e43d27a03e01c5c902c6dd70f496.svg";
export { ForwardRef as ReactComponent };